<template>
  <div>
    <div v-if="abstract">
      <div class="row mt-4 border p-2">
        <div class="col-2 d-flex">
          <icon :icon="['fad', 'check']" class="text-success fa-8x mx-auto my-auto"/>
        </div>
        <div class="col-4">
          <div class="row">
            <div class="col text-success">
              <h5>{{ _[abstract.setting_submission_id].submit_success.titel }}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <speaker :submission_id="abstract.setting_submission_id" area="submit_success"
                       textkey="intro_mail"></speaker>
              <br>
              <br>
              <strong>{{ user.emailBusiness }}</strong>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <router-link :to="'/home'">
                <button class="btn btn-success">
                  <icon :icon="['fad', 'home']" class=""/>
                  {{ wording[0].navigation.home }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-2 border-left d-flex">
          <icon :icon="['fal', 'file-pdf']" class="text-info fa-5x mx-auto my-auto"/>
        </div>
        <div class="col d-flex flex-column">
          <div class="row">
            <div class="col text-success">
              <h5>
                <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                         textkey="pdf_download_title"></Speaker>
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                       textkey="pdf_download_text"></Speaker>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col d-flex">
              <button class="btn btn-success" v-if="processing.pdf === false" v-on:click="GET_PDF($route.params.id)">
                <icon :icon="['fad', 'download']" class="mx-auto my-auto"/>
                {{ wording[0].buttons.download }}
              </button>
              <ProcessingButton v-else></ProcessingButton>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(settings).includes('payment') && settings.payment === true" class="row mt-4 border p-2">
        <div class="col-2 d-flex">
          <icon :icon="['fad', 'receipt']" class="text-info fa-10x mx-auto my-auto"/>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col text-success">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <payment_invoice :abstract_id="$route.params.id"></payment_invoice>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 border p-2">
        <div class="col-2 d-flex">
          <icon :icon="['fad', 'info']" class="text-info fa-10x mx-auto my-auto"/>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col text-success">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <speaker :submission_id="abstract.setting_submission_id" area="submit_success"
                       textkey="helptext"></speaker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import Payment_invoice from "@/components/payment/payment_invoice.vue";

export default {
  name: "SubmitSuccess",
  components: {Payment_invoice},
  computed: {
    ...mapState([
      'user', 'abstract', 'wording', 'processing', 'settings'
    ]),
  },
  methods: {
    ...mapActions(['GET_PDF']),
  }
}
</script>

<style scoped>

</style>
